import React from "react";
import { Megaphone } from "lucide-react";

const BASE_IMAGE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "";

const AnnouncementDisplay = ({ announcement, parent_Id }) => {
  if (!announcement) {
    return (
      <div className="flex justify-center items-center h-full w-full bg-transparent text-gray-700">
        No Announcement
      </div>
    );
  }

  const { title, imageLink } = announcement;
  const imageUrl = imageLink ? `${BASE_IMAGE_URL}/${imageLink}` : null;

  return (
    <div
      className={`relative overflow-hidden ${parent_Id === null ? "h-[100svh]" : "sm:h-[70svh]"
        }`}
    >
      {/* Announcement Tag */}
      <div className="absolute top-[2svh] left-[1.5svh] flex items-center gap-2 bg-yellow-100 text-yellow-800 px-[2svh] py-[0.5svh] rounded-full shadow-sm z-20">
        <Megaphone className="w-[3.2svh] h-auto" />
        <span className="font-semibold text-[2.3svh] uppercase">Announcement</span>
      </div>

      {/* Image or Title */}
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={title || "Announcement"}
          className={`h-full w-full ${parent_Id === null ? "object-contain sm:object-cover" : "object-cover"
    }`}
        />
      ) : (
        <div className="absolute inset-0 flex flex-col justify-center items-center text-center bg-transparent p-6">
          <p className="text-black text-2xl font-semibold leading-snug max-w-[80%]">
            {title || "No Title"}
          </p>
        </div>
      )}
    </div>
  );
};

export default AnnouncementDisplay;